module.exports = __webpack_public_path__ + "static/img/stage-mode-1.bf38beb6.png";